import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {FieldPath, FieldValues, useFormContext} from "react-hook-form";
import * as React from "react";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select.tsx";
import * as SelectPrimitive from "@radix-ui/react-select";

type SelectInputFieldProps<T extends FieldValues> = {
    name: FieldPath<T>,
    title?: string,
    defaultValue?: string,
    options: readonly string[] | Record<string, string>,
    nullable?: boolean
} & React.ComponentProps<typeof SelectPrimitive.Value>;

export default function SelectInputField<T extends FieldValues>(
    {name, title, options, defaultValue = "", nullable = false, ...props}: SelectInputFieldProps<T>) {
    const {control} = useFormContext()

    return (
        <FormField control={control} name={name} render={({field}) => (
            <FormItem>
                {title && <FormLabel>{title}</FormLabel>}
                <Select value={field.value ? String(field.value) : defaultValue} onValueChange={field.onChange}>
                    <FormControl>
                        <SelectTrigger className="w-full">
                            <SelectValue {...props}/>
                        </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                        {nullable && <SelectItem key="none" value={undefined!}>-</SelectItem>}
                        {Array.isArray(options) ?
                            options.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>) :
                            Object.entries(options as Record<string, string>)
                                .map(([k, v]) => <SelectItem key={k} value={k}>{v}</SelectItem>)
                        }
                    </SelectContent>
                </Select>
                <FormMessage/>
            </FormItem>
        )}/>
    )
}
